import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of, shareReplay, tap, throwError, timeout } from 'rxjs';
import { environment } from 'environments/environment';
import { setSicaRouteCatalog, SicaCatalogContext } from 'app/shared/utils/sica-route-catalog';

@Injectable({ providedIn: 'root' })
export class SicaRouteCatalogService {
    private readonly client: HttpClient;
    private request$: Observable<void>;
    private loaded = false;

    constructor(backend: HttpBackend) {
        this.client = new HttpClient(backend);
    }

    /** Public pages do not call this. Load metadata only for an authenticated session. */
    load(): Observable<void> {
        if (this.loaded) {
            return of(undefined);
        }

        if (!this.request$) {
            this.request$ = this.client.get<SicaCatalogContext[]>(environment.RESOURCE_API + environment.apiCatalog.sicaRoutes.controllerRoute
                + environment.apiCatalog.sicaRoutes.subRoutes.catalog).pipe(
                timeout(15000),
                tap(contexts => setSicaRouteCatalog(contexts)),
                map(() => { this.loaded = true; }),
                catchError(error => {
                    this.request$ = undefined;
                    return throwError(() => error);
                }),
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }
        return this.request$;
    }
}
